var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":"https://static.offch.com/storage/logo/rightel-logo-min.png","max-width":"50px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }